// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1GO1f","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2tfoR","obliqueLine":"membershipbadge_obliqueLine__1CCvs"};